<template>
  <div class="d-flex flex-column white poi-card">
    <div
      :style="insets && insets.top > 0 ? main : 'margin-top: 8px'"
      class="primary rounded-circle d-flex align-center return-button ml-2"
      @click="$emit('close')"
    >
      <v-btn icon>
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>
    </div>

    <v-card class="elevation-0">
      <v-carousel
        v-model="model"
        hide-delimiters
        height="auto"
        :continuous="false"
        v-if="poi.images != null && poi.images.length > 0"
      >
        <v-carousel-item v-for="(image, i) in poi.images" :key="image + i">
          <v-img
            v-once
            :aspect-ratio="16 / 9"
            :src="'https://api.e-naxios.com/images/' + image.image[0].file_name"
          ></v-img>
        </v-carousel-item>
      </v-carousel>
      <div
        v-else
        style="width: 100%; height: 150px"
        class="d-flex align-center justify-center"
      >
        <v-icon size="100" color="primary"> mdi-image-off-outline </v-icon>
      </div>

      <div class="d-flex flex-column px-4 py-2">
        <div class="d-flex align-center mb-2">
          <div class="d-flex flex-column mr-auto">
            <span
              class="primary--text text--darken-2 font-weight-regular text-h6 mr-auto"
            >
              {{ poi.name }}
            </span>

            <span
              class="primary--text text--darken-2 font-weight-regular text-caption mr-auto"
            >
              {{ poiCategory(poi.category_id).name }}
            </span>
          </div>

          <lottie
            :options="defaultOptions"
            :height="35"
            :width="35"
            class="pa-0 ma-0 pb-1"
            v-if="playing"
          />

          <v-btn
            v-if="!isLanguageSupported"
            icon
            class="warning-button"
            @click="dialog = true"
          >
            <v-icon color="white" class="warning rounded-circle" size="20">
              mdi-alert-circle-outline
            </v-icon>
          </v-btn>

          <v-btn
            icon
            :class="
              playDescirption || !isLanguageSupported ? '' : 'pulse-button'
            "
            @click="play"
            :disabled="!isLanguageSupported"
          >
            <v-icon
              color="white"
              class="accent rounded-circle"
              :class="isLanguageSupported ? 'accent ' : 'grey'"
              size="20"
            >
              mdi-play
            </v-icon>
          </v-btn>

          <v-btn icon @click="stop" :disabled="!playing">
            <v-icon
              color="white"
              class="rounded-circle"
              size="20"
              :class="playing ? 'accent' : 'grey'"
            >
              mdi-stop
            </v-icon>
          </v-btn>

          <!-- <v-btn icon @click="share">
            <v-icon color="white" class="rounded-circle accent" size="15">
              mdi-share
            </v-icon>
          </v-btn> -->

          <v-btn icon @click="visit">
            <v-icon
              color="white"
              class="rounded-circle"
              :class="!isChecked ? 'accent' : 'success'"
              size="15"
            >
              mdi-check
            </v-icon>
          </v-btn>
        </div>

        <v-divider class="mb-4"></v-divider>

        <span class="mb-16" :class="'body-2 '" v-html="poi.description"> </span>
      </div>
    </v-card>
    <v-dialog v-model="dialog" fullscreen>
      <Instructions @close="dialog = false" />
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { TextToSpeech } from "@capacitor-community/text-to-speech";
import { decodeEntities } from "@/utils/decodeEntities";
import axios from "axios";
import { Filesystem, Directory } from "@capacitor/filesystem";

import { Share } from "@capacitor/share";

import Lottie from "vue-lottie";
import animationData from "@/assets/audio_playing.json";
import Instructions from "@/components/Instructions.vue";

export default {
  components: {
    lottie: Lottie,
    Instructions,
  },

  props: {
    poi: Object,
  },

  async mounted() {
    try {
      if (this.autoPlayTTS && this.isLanguageSupported) await this.play();

      const found = this.visitedPois.find((el) => el.id == this.poi.id);
      if (found != null) this.isChecked = true;
    } catch (e) {
      console.log(e);
    }
  },

  async destroyed() {
    try {
      await this.stop();
    } catch (e) {
      console.log(e);
    }
  },

  data() {
    return {
      playDescirption: false,
      model: 0,
      defaultOptions: { animationData: animationData },
      dialog: false,
      isChecked: false,

      // poi: null,
    };
  },

  computed: {
    ...mapState({
      sound: (state) => state.base.sound,
      mobileLang: (state) => state.base.mobileLang,
      categories: (state) => state.pois.categories,
      isLanguageSupported: (state) => state.base.isLanguageSupported,
      autoPlayTTS: (state) => state.base.autoPlayTTS,
      playing: (state) => state.base.isPlaying,
      insets: (state) => state.base.insets,
      visitedPois: (state) => state.pois.visitedPois,
    }),

    main() {
      return {
        margin: `${this.insets?.top}px 0px 0px 0px`,
      };
    },

    decodedDescription() {
      const description = decodeEntities(this.poi.description).replace(
        /[\r\n]/gm,
        ""
      );
      // if (description.length >= 800 && this.mobileLang.code == "el") {
      //   console.log(description.length);
      //   const substrings = [];
      //   for (let i = 0; i < description.length; i += 800) {
      //     const substring = description.substr(i, 800);
      //     substrings.push(substring);
      //   }
      //   return substrings;
      // } else {
      return description;
    },
    // },
  },

  methods: {
    ...mapMutations(["togglePlaying"]),
    ...mapActions(["toggleSound", "setVisitedPois"]),

    poiCategory(category_id) {
      return this.categories.find((el) => el.id == category_id);
    },

    visit() {
      this.isChecked = !this.isChecked;
      this.setVisitedPois({
        poi: this.poi,
        isChecked: this.isChecked,
      });
      this.$store.commit("toggleSnackbar", {
        open: true,
        text: this.isChecked
          ? this.$t("messages.add_visited")
          : this.$t("messages.remove_visited"),
        color: "secondary",
      });
    },

    getBase64(url) {
      return axios
        .get(url, {
          responseType: "arraybuffer",
        })
        .then((response) =>
          Buffer.from(response.data, "binary").toString("base64")
        );
    },

    async share() {
      //1. get image as base64
      // this function just downloads the file from link and converts to base64

      const b64image = await this.getBase64(
        "https://api.e-naxios.com/images/" +
          this.poi.images[0].image[0].file_name
      );

      //2.  save file in cache
      await Filesystem.writeFile({
        path:
          "https://api.e-naxios.com/images/" +
          this.poi.images[0].image[0].file_name,
        data: b64image,
        directory: Directory.Cache,
      });

      //3. get full uri of the saved image
      let imgData = await Filesystem.getUri({
        path:
          "https://api.e-naxios.com/images/" +
          this.poi.images[0].image[0].file_name,
        directory: Directory.Cache,
      });

      //4. Share
      await Share.share({
        title: this.poi.name,
        text: this.decodedDescription,
        url: imgData.uri,
        dialogTitle: "Share",
      });
    },

    async play() {
      try {
        if (this.sound == "0") {
          this.$store.commit("toggleSnackbar", {
            open: true,
            text: this.$t("error_messages.unmute"),
            color: "secondary",
          });
          return;
        }
        this.playDescirption = true;
        this.togglePlaying(true);

        // if (Array.isArray(this.decodedDescription)) {
        //   for (let i = 0; i < this.decodedDescription.length; i++) {
        //     await TextToSpeech.speak({
        //       lang: this.mobileLang.code,
        //       // rate: 0.9,
        //       pitch: 1.0,
        //       volume: 1.0,
        //       category: "playback",
        //       text: this.decodedDescription[i],
        //     });
        //   }
        // } else {
        await TextToSpeech.speak({
          lang: this.mobileLang.code,
          // rate: 0.9,
          pitch: 1.0,
          volume: 1.0,
          category: "playback",
          text: this.decodedDescription,
        });
        // }
        this.togglePlaying(false);
      } catch (e) {
        this.togglePlaying(false);

        console.log(e);
      }
      this.togglePlaying(false);
    },

    async stop() {
      try {
        await TextToSpeech.stop();
        this.togglePlaying(false);
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.return-button {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}
.pulse-button {
  -webkit-animation: pulse 1.5s infinite;
  box-shadow: 0 0 0 0 rgba(#5a99d4, 0.5);
}

.poi-card {
  height: calc(100vh - 56px);
}

.pulse-button:hover {
  -webkit-animation: none;
}

@-webkit-keyframes pulse {
  0% {
    // transform: scale(1);
  }
  70% {
    // transform: scale(1.05);
    box-shadow: 0 0 0 5px rgba(90, 153, 212, 0);
  }
  100% {
    // transform: scale(1);
    box-shadow: 0 0 0 0 rgba(90, 153, 212, 0);
  }
}
</style>
